import styled from "styled-components";
import { FormControlLabel } from "@material-ui/core";

export const RadioWrapper = styled.div`
  flex: 0 0 100%;
  padding: 0 10px;
`;

export const FormControlStyledLabel = styled(FormControlLabel)`
  display: flex;

  a {
    color: ${(props) => props.theme.primaryColor};
  }

  svg {
    font-size: 1rem;
    margin-left: 2px;
  }

  &.error {
    svg,
    a,
    span {
      color: ${(props) => props.theme.error};
    }
  }
`;
